import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Modal from 'react-bootstrap/Modal';
import ModalHeader from '../../../components/ModalHeader';
import { Container, Row, Col } from 'react-bootstrap';
import Button from '../../../components/Button';

export type OtherBenefitsType = {
  title?: string;
  subTitles: { subTitle: string; link: string; target: string }[];
}[];

const OtherBefitsOptions: OtherBenefitsType = [
  {
    subTitles: [
      {
        subTitle: 'Purchase Time Off : PTO',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Pet Insurance - How to Enroll',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Quit for Life Program Summary',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'ID Watchdog Benefit Summary',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
      {
        subTitle: 'Commuter Benefits Reference Guide',
        link: `${process.env.PUBLIC_URL}/${'blank-demo-example.pdf'}`,
        target: '_blank',
      },
    ],
  },
];

export type OtherBenefitsProps = {
  showOtherBenefitsModal: boolean;
  handleCloseOtherBenefitsModal: () => void;
};

function OtherBenefitsModal({
  showOtherBenefitsModal,
  handleCloseOtherBenefitsModal,
}: OtherBenefitsProps) {
  return (
    <>
      <Modal
        className={'p-0'}
        show={showOtherBenefitsModal}
        onHide={handleCloseOtherBenefitsModal}
        dialogClassName="modal-xl"
        aria-labelledby="example-custom-modal-styling-title"
      >
        <ModalHeader closeButton={true} leftIcon={light('folder')}>
          <h4 className="text-sm-20-lg-24">Other Benefits</h4>
        </ModalHeader>
        <Modal.Body>
          <Container className={'p-0'}>
            {OtherBefitsOptions.map(({ title, subTitles }, index) => {
              return (
                <Row key={index}>
                  <Col>
                    <h6
                      className={
                        'mb-0 pb-4 border-bottom border-info text-primary text-fs-base fw-normal'
                      }
                    >
                      {title}
                    </h6>
                  </Col>
                  <Col className={'col-12 mc-layout-2-col mb-12'}>
                    {subTitles.map(({ subTitle, link, target }, index) => {
                      return (
                        <Row key={index}>
                          <Col>
                            <div
                              className={
                                'd-flex mb-0 py-6 text-fs-6 border-bottom border-info fw-light'
                              }
                              key={index}
                            >
                              {subTitle}
                              <a
                                className={'text-decoration-none ms-auto'}
                                href={link}
                                target= {target}
                              >
                                <FontAwesomeIcon icon={light('file-pdf')} />
                                <span className={'ms-5'}>PDF</span>
                              </a>
                            </div>
                          </Col>
                        </Row>
                      );
                    })}
                  </Col>
                </Row>
              );
            })}
          </Container>
        </Modal.Body>
        <Modal.Footer className={'pt-0'}>
          <Button
            variant="primary-outline"
            onMouseDown={handleCloseOtherBenefitsModal}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default OtherBenefitsModal;
